import { useParams } from 'react-router-dom'

import { RouteParams } from '@/routes/routes'

export default function usePurchaseOrderId() {
  const { purchaseOrderId } = useParams<RouteParams['PURCHASE_ORDER']>()
  return purchaseOrderId
}
